export default "https://app.formydoc.com/static/doctor-red.png";